import { render } from "./TroopOverview.vue?vue&type=template&id=df44cac8"
import script from "./TroopOverview.vue?vue&type=script&lang=js"
export * from "./TroopOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tooltips/troops/TroopOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df44cac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df44cac8', __exports__)) {
    api.reload('df44cac8', __exports__)
  }
  
  module.hot.accept("./TroopOverview.vue?vue&type=template&id=df44cac8", () => {
    api.rerender('df44cac8', render)
  })

}


export default __exports__